import envConfig from '../../static/config';
import config from '../config';

import ApiUtils from './ApiUtils';
import RenameAccountsActionCreator from '../actions/RenameAccountsActionCreator';

const _accountReorderEndPoint =
  '/ibapi/v2/banks/{bank-id}/accounts/default/attributes';

class RenameAccountApiUtils {
  static updateAccountName(requestPacket) {
    const requestData = {
      accounts: [],
    };
    const account = {
      id: requestPacket.id,
      display_name: requestPacket.displayName,
    };
    requestData.accounts.push(account);

    const url = `${envConfig.apiBaseUrlPAAS}${_accountReorderEndPoint}`;
    ApiUtils.makeAjaxCall(
      {
        apiVersion: config.apiVersions.renameServices,
        method: 'PUT',
        url,
        addAuthToken: true,
        requestData,
      },
      (body) => {
        RenameAccountsActionCreator.handleSuccess(body);
      },
      (error) => {
        RenameAccountsActionCreator.handleFail(error);
      }
    );
  }
}

export default RenameAccountApiUtils;
